export const replaceExtraSeparators = (dateInput: string) => {
  return dateInput.trim().replace(/[/:.,-\s]+/g, '/');
};
